import { render, staticRenderFns } from "./newInfo.vue?vue&type=template&id=66bab621&scoped=true&"
import script from "./newInfo.vue?vue&type=script&lang=js&"
export * from "./newInfo.vue?vue&type=script&lang=js&"
import style0 from "./newInfo.vue?vue&type=style&index=0&id=66bab621&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bab621",
  null
  
)

component.options.__file = "newInfo.vue"
export default component.exports